import { Box, Grid, Typography } from "@mui/material";
import { useSelectedProject } from "Hooks";
import { ApiAPITokenType } from "@incendium/api";
import APITokenCard from "../components/APITokenCard";
import Woo from "Assets/Images/ThirdParty/woocommerce-logo-color-black@2x.png";
import Shopify from "Assets/Images/ThirdParty/shopify_logo_black.png";
import Stripe from "Assets/Images/ThirdParty/stripe-small.png";
import Loading from "Components/Loading/Loading";

function WebhooksList() {
  const { selectedClient, selectedProject } = useSelectedProject();

  if (!selectedClient?.id || !selectedProject?.id) {
    return (
      <Box display={"flex"} my={4}>
        <Loading />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={4}>
        <APITokenCard
          title="Woocommerce"
          type={ApiAPITokenType.API_TOKEN_TYPE_WOOCOMMERCE}
          clientId={selectedClient.id}
          projectId={selectedProject.id}
          projectKey={selectedProject.key || ""}
          logo={Woo}
          info={
            <Box>
              <Typography variant="body2" color={"text.secondary"}>
                Selecting this will generate an auth key. Use this key for
                Woocommerce.
              </Typography>
            </Box>
          }
        />
      </Grid>
      <Grid item xs={4}>
        <APITokenCard
          title="Shopify Webhooks"
          type={ApiAPITokenType.API_TOKEN_TYPE_SHOPIFY}
          clientId={selectedClient.id}
          projectId={selectedProject.id}
          projectKey={selectedProject.key || ""}
          logo={Shopify}
          imageSx={{ maxHeight: 35 }}
          drawerMaxWidth={700}
          info={
            <Box>
              <Typography variant="body2" color={"text.secondary"}>
                Selecting this will generate an auth key. Use this key to add
                Incendium Webhooks to your store.
              </Typography>
            </Box>
          }
        />
      </Grid>
      <Grid item xs={4}>
        <APITokenCard
          title="Stripe"
          type={ApiAPITokenType.API_TOKEN_TYPE_STRIPE}
          clientId={selectedClient.id}
          projectId={selectedProject.id}
          projectKey={selectedProject.key || ""}
          logo={Stripe}
          imageSx={{ transform: `translateX(-10px)` }}
          info={
            <Box>
              <Typography variant="body2" color={"text.secondary"}>
                Selecting this will generate a URL for use in Stripe. We
                recommend using either the payment_intent.succeeded event for
                one-time payments or the invoice.paid event for subscriptions.
              </Typography>
            </Box>
          }
        />
      </Grid>
    </Grid>
  );
}

export default WebhooksList;
